import React from 'react'
import { Box } from '../chakra/Box'
import UserProfileImg from '../UserProfileImg'
import { css } from '@emotion/react'
import VerticalSpace from '../VerticalSpace'
import theme from '../../constants/theme'

const styles = {
  usersContainer: css`
    padding: 1rem;
  `,
  userList: css`
    display: flex;
    flex-direction: column;
  `,

  userWrapper: css`
    padding: 10px;
    margin-top: 10px;
    width: 300px;

    background: ${theme.colors.card.background.dark};
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;
    cursor: pointer;
    &:hover {
      box-shadow: ${theme.shadows.outline};
    }
  `,
  image: css``,
  userInfo: css`
    display: flex;
    align-items: center;
    gap: 10px;
  `,
  imageContainer: css`
    height: 50px;
    width: 50px;
    border-radius: 50%;
    overflow: hidden;
  `,
}

function FolderUser({ user, isOwner }) {
  return (
    <Box css={styles.userWrapper}>
      <Box css={styles.userInfo}>
        <Box css={styles.imageContainer}>
          <UserProfileImg imageUrl={user.image} />
        </Box>
        <h1
          css={css`
            color: ${theme.colors.text.dark};
          `}
        >
          {user.name}
        </h1>
      </Box>

      {isOwner ? (
        <h1
          css={css`
            color: ${theme.colors.custom.gray};
          `}
        >
          Owner
        </h1>
      ) : null}
    </Box>
  )
}
function FolderUsers({ folder }) {
  return (
    <Box css={styles.usersContainer}>
      <VerticalSpace space={4} />
      <h1>Collaborators</h1>
      <VerticalSpace space={1} />
      <FolderUser user={folder.user} isOwner={true} />

      <Box css={styles.userList}>
        {folder.shared.map(shared => (
          <FolderUser user={shared.user} />
        ))}
      </Box>
    </Box>
  )
}

export default FolderUsers
